import { render } from "./JobCategory.vue?vue&type=template&id=3b6ca1bf"
import script from "./JobCategory.vue?vue&type=script&lang=js"
export * from "./JobCategory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__